import { render, staticRenderFns } from "./ProductEditor.vue?vue&type=template&id=47b3a00a"
import script from "./ProductEditor.vue?vue&type=script&lang=ts"
export * from "./ProductEditor.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports